import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Checkbox, FlexGap, tokens } from '@treams/treams-ui';

type TaskItem = graphql.NoteTaskFragment;

const TaskTitle = styled.span`
	flex: 1;
	min-width: 0;
	font-size: ${tokens.typography.sizes.h3}px;
	color: ${tokens.text.primary};
	padding: ${tokens.gap.inline}px 0;
`;

export default function NoteTaskLineReadOnly({ task }: { task: TaskItem }) {
	const { t } = useTranslation();
	const isDone = task.status === graphql.TaskStatus.Done;

	return (
		<FlexGap mb={2} alignItems="center" gap={8}>
			<Checkbox
				mr={0}
				checked={isDone}
				disabled
				aria-label={isDone ? t('oneOnOne.tasks.statusDone') : t('oneOnOne.tasks.statusTodo')}
			/>
			<TaskTitle>{task.title}</TaskTitle>
		</FlexGap>
	);
}
